import { useState } from 'react';
import './faq.css';
export const FaqItem = ( {title, content, boxSize} ) => {
    const [itemOpen, setItemOpen] = useState(false);
    return (
        <div className='faq-item'>
            <div className="faq-item-title" onClick={(e)=>itemOpen ? setItemOpen(false): setItemOpen(true)}>
                <h3>{title}</h3>
                <svg width="12" height="7" viewBox="0 0 12 7" fill="#fff" style={{paddingTop:"2px"}} xmlns="http://www.w3.org/2000/svg"><path d="M1.33325 1.25L5.99992 5.91667L10.6666 1.25" stroke="white" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>
            <div className={ itemOpen ? "faq-item-content expanded-faq" : "faq-item-content"}  style={{height: `${itemOpen ? boxSize : "0"}`, visibility: `${itemOpen ? "visible" : "hidden"}`, padding: `${itemOpen ? "10px": "0"}`}}>
                {content}
            </div>
        </div>
    )
  }